import styles from './Aguardando.module.css';
import { ehEndpointAusente } from './endpointAusente';

/**
 * Estado explícito "aguardando backend" (cláusula anti-fachada do plano §11.2).
 *
 * Quando o endpoint que serve um elemento ainda não existe, o elemento NÃO
 * some e NÃO inventa dado: ele aparece desabilitado, com o caminho do endpoint
 * à vista e o motivo por extenso. Foi tela decorativa que custou o projeto.
 */
export function Aguardando({ endpoint, o_que }: { endpoint: string; o_que: string }) {
  return (
    <div className={styles.root} role="status">
      <span className={styles.tag}>Aguardando backend</span>
      <p className={styles.txt}>
        {o_que} depende de <code className={styles.code}>{endpoint}</code>, que ainda não
        responde nesta instalação. Nada é exibido no lugar: sem endpoint, não há dado.
      </p>
    </div>
  );
}

/** Falha de leitura que NÃO é ausência de endpoint (403, 500, rede). */
export function FalhaLeitura({ endpoint, erro }: { endpoint: string; erro: unknown }) {
  const msg = erro instanceof Error ? erro.message : String(erro);
  return (
    <div className={`${styles.root} ${styles.falha}`} role="alert">
      <span className={`${styles.tag} ${styles.tagFalha}`}>Falha ao ler</span>
      <p className={styles.txt}>
        <code className={styles.code}>{endpoint}</code> respondeu com erro: {msg}
      </p>
    </div>
  );
}

/**
 * Escolhe o painel certo para um estado de leitura. Devolve `null` quando não
 * há erro — quem chama segue renderizando o conteúdo real.
 */
export function PainelDeErro({ endpoint, o_que, erro }: {
  endpoint: string;
  o_que: string;
  erro: unknown;
}) {
  if (!erro) return null;
  return ehEndpointAusente(erro) ? (
    <Aguardando endpoint={endpoint} o_que={o_que} />
  ) : (
    <FalhaLeitura endpoint={endpoint} erro={erro} />
  );
}
